import React, { useState } from "react";
import { FiAlertTriangle, FiAlertCircle, FiInfo } from "react-icons/fi";
import { severityColor, SeverityBadge } from "./stpHelpers";

const CAT_ICONS = { Process:"⚗", Blower:"💨", Pump:"⚙", Inlet:"💧", Energy:"⚡", Sludge:"🔵", Compliance:"📋" };

const StpAlertsPanel = ({ d }) => {
  const [filterSev, setFilterSev] = useState("All");
  const [filterAck, setFilterAck] = useState("All");
  const [selected, setSelected]   = useState(null);

  const filtered = d.alerts.filter(a => {
    const s = filterSev === "All" || a.severity === filterSev;
    const k = filterAck === "All" || (filterAck === "Unacked" ? !a.ack : a.ack);
    return s && k;
  });

  const critical = d.alerts.filter(a => a.severity === "Critical").length;
  const warning  = d.alerts.filter(a => a.severity === "Warning").length;
  const info     = d.alerts.filter(a => a.severity === "Info").length;
  const unacked  = d.alerts.filter(a => !a.ack).length;
  const sel = selected ? d.alerts.find(a => a.id === selected) : null;

  return (
    <div className="stp-alerts-panel">

      <div className="stp-alert-summary">
        {[
          { label: "Critical", count: critical, color: "#ef4444", bg: "#fee2e2", icon: FiAlertTriangle },
          { label: "Warning",  count: warning,  color: "#f59e0b", bg: "#fef3c7", icon: FiAlertCircle  },
          { label: "Info",     count: info,     color: "#3b82f6", bg: "#dbeafe", icon: FiInfo         },
          { label: "Unack'd",  count: unacked,  color: "#8b5cf6", bg: "#ede9fe", icon: FiAlertTriangle },
        ].map(s => (
          <div key={s.label} className="stp-al-sum-card" style={{ borderTopColor: s.color, background: s.bg }}>
            <s.icon size={18} color={s.color} />
            <div className="stp-als-num" style={{ color: s.color }}>{s.count}</div>
            <div className="stp-als-lbl">{s.label}</div>
          </div>
        ))}
      </div>

      <div className="stp-view-row">
        {["All","Critical","Warning","Info"].map(f => (
          <button key={f} className={`stp-view-btn ${filterSev === f ? "stp-view-active" : ""}`} onClick={() => setFilterSev(f)}>{f}</button>
        ))}
        <span style={{ margin: "0 8px", color: "#d1d5db" }}>|</span>
        {["All","Unacked","Acked"].map(f => (
          <button key={f} className={`stp-view-btn ${filterAck === f ? "stp-view-active" : ""}`} onClick={() => setFilterAck(f)}>{f}</button>
        ))}
      </div>

      <div className="stp-alerts-body">
        <div className="stp-alert-list">
          {filtered.map(a => {
            const sc = severityColor(a.severity);
            return (
              <div key={a.id} className={`stp-alert-card ${a.id === selected ? "stp-alert-sel" : ""}`}
                style={{ borderLeftColor: sc.color }} onClick={() => setSelected(a.id === selected ? null : a.id)}>
                <div className="stp-ac-top">
                  <span className="stp-ac-cat">{CAT_ICONS[a.category] || "⚡"} {a.category}</span>
                  <SeverityBadge severity={a.severity} />
                  <span className="stp-badge" style={{ background: a.ack ? "#d1fae5" : "#fee2e2", color: a.ack ? "#10b981" : "#ef4444", marginLeft: "auto", fontSize: 10 }}>
                    {a.ack ? "✓ Acked" : "Unack'd"}
                  </span>
                </div>
                <div className="stp-ac-msg">{a.message}</div>
                <div className="stp-ac-meta">
                  <span>Tank: {a.tank}</span>
                  <span>Param: {a.parameter}</span>
                  <span>Value: {a.value}</span>
                  <span>🕐 {a.time}</span>
                  {a.assignedTo && <span>👤 {a.assignedTo}</span>}
                </div>
              </div>
            );
          })}
          {filtered.length === 0 && <div className="stp-empty">No alerts match current filter.</div>}
        </div>

        {sel && (
          <div className="stp-alert-detail">
            <div className="stp-ad-title">Alert Detail — {sel.id}</div>
            <SeverityBadge severity={sel.severity} />
            <div className="stp-ad-msg">{sel.message}</div>
            <div className="stp-ad-grid">
              <div><label>Tank</label><span>{sel.tank}</span></div>
              <div><label>Parameter</label><span>{sel.parameter}</span></div>
              <div><label>Value</label><span style={{ color: "#ef4444", fontWeight: 600 }}>{sel.value}</span></div>
              <div><label>Category</label><span>{sel.category}</span></div>
              <div><label>Time</label><span>{sel.time}</span></div>
              <div><label>Ack'd</label><span>{sel.ack ? `Yes — ${sel.assignedTo}` : "No"}</span></div>
            </div>
            <div className="stp-ad-actions">
              {!sel.ack && <button className="stp-ctrl-btn stp-ctrl-green">✓ Acknowledge</button>}
              <button className="stp-ctrl-btn stp-ctrl-blue">👤 Assign Tech</button>
            </div>
            {sel.severity === "Critical" && (
              <div className="stp-ad-ai">
                🤖 AI: {sel.category === "Process" ? "Increase blower RPM to restore DO above 2.0 mg/L immediately." :
                  sel.category === "Compliance" ? "Pre-emptive dosing adjustment recommended before limit breach." :
                  sel.category === "Blower" ? "Check BL-04 electrical supply and motor thermal protection." :
                  "Immediate inspection required."}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default StpAlertsPanel;
